import { render, staticRenderFns } from "./AdminSupportStaffModal.vue?vue&type=template&id=7c9807f6&scoped=true"
import script from "./AdminSupportStaffModal.vue?vue&type=script&lang=js"
export * from "./AdminSupportStaffModal.vue?vue&type=script&lang=js"
import style0 from "./AdminSupportStaffModal.vue?vue&type=style&index=0&id=7c9807f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9807f6",
  null
  
)

export default component.exports